import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'
import TitleBasic, {titleBasicColors, titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {useUtils} from '../../hooks/useUtils.js'
import {PANEL_FINANCING_VERSION} from '../config.js'
import {PanelFinancingInstalmentSelector} from './PanelFinancingInstalmentSelector.js'

const BASE_CLASS = 'mt-PanelFinancing'

export const PanelFinancingInstalment = ({
  handleOnChangeSelectedFare = () => {},
  isProfessional,
  loanCalculations,
  panelFinancingVersion = PANEL_FINANCING_VERSION.B2C,
  selectedFare = false
}) => {
  const {i18n} = useContext(Context)

  const {getValueFormated} = useUtils()

  const {fee} = loanCalculations || {}

  const instalmentTitle = isProfessional ? 'COMMON.FEE_FROM' : 'COMMON.FEE'

  const formatedFee = getValueFormated(fee)

  const classNameInlineField = cx(`${BASE_CLASS}-instalmentContainer`, {
    [`${BASE_CLASS}-instalmentContainer--inline`]: !isProfessional
  })

  return (
    <>
      {panelFinancingVersion === PANEL_FINANCING_VERSION.B2C && (
        <PanelFinancingInstalmentSelector
          handleOnChangeSelectedFare={handleOnChangeSelectedFare}
          isProfessional={isProfessional}
          loanCalculations={loanCalculations}
          selectedFare={selectedFare}
        />
      )}
      {panelFinancingVersion === PANEL_FINANCING_VERSION.C2C && (
        <div className={classNameInlineField}>
          <TitleBasic
            as={titleBasicTags.h4}
            color={titleBasicColors.black}
            size={titleBasicSizes.xxs}
            title={`${i18n.t(instalmentTitle)}`}
          />
          <div className={`${BASE_CLASS}-instalmentItem`}>
            <span className={`${BASE_CLASS}-instalment`}>{formatedFee}</span>
            <TitleBasic
              as={titleBasicTags.h4}
              color={titleBasicColors.black}
              size={titleBasicSizes.xxs}
              title={`/${i18n.t('COMMON.PLURALS.MONTH', 1).toLowerCase()}*`}
            />
          </div>
        </div>
      )}
      {panelFinancingVersion === PANEL_FINANCING_VERSION.SIMPLIFIED && (
        <div className={`${BASE_CLASS}-instalmentContainerSimplified`}>
          <TitleBasic
            as={titleBasicTags.h4}
            color={titleBasicColors.black}
            size={titleBasicSizes.xxs}
            title={`${i18n.t(instalmentTitle)}`}
          />
          <div className={`${BASE_CLASS}-instalmentItem`}>
            <span className={`${BASE_CLASS}-instalment`}>{formatedFee}</span>
            <TitleBasic
              as={titleBasicTags.h4}
              color={titleBasicColors.black}
              size={titleBasicSizes.xxs}
              title={`/${i18n.t('COMMON.PLURALS.MONTH', 1).toLowerCase()}*`}
            />
          </div>
        </div>
      )}
    </>
  )
}

PanelFinancingInstalment.propTypes = {
  isProfessional: PropTypes.string,
  handleOnChangeSelectedFare: PropTypes.func,
  loanCalculations: PropTypes.object,
  panelFinancingVersion: PropTypes.string,
  selectedFare: PropTypes.bool
}
